module.exports = __webpack_public_path__ + "static/media/arrow.e2e31208.svg";